import { businessKey } from 'queryKeys';

export const INFLUENCERS_CHANNELS = 'influencers_сhannels';
const MUTATION_EXPORT_CATEGORIES = 'export_catergories';
const MUTATION_EXPORT_INFLUENCER_CHANNEL = 'export_influencer_channel';
const MUTATION_UPLOAD_CATEGORIES = 'upload_categories';
const MUTATION_UPLOAD_INFLUENCER_CHANNEL = 'upload_influencer_channels';

const influencersChannelsQuery = businessKey.query(INFLUENCERS_CHANNELS);

export const grids = influencersChannelsQuery.grids();
export const grid = influencersChannelsQuery.grid();

export const details = influencersChannelsQuery.details();
export const model = influencersChannelsQuery.exact();

export const mutations = influencersChannelsQuery.mutations();

export const remove = mutations.delete();
export const create = mutations.create();
export const update = mutations.update();
export const exportCategories = mutations.mutate(MUTATION_EXPORT_CATEGORIES);
export const exportInfluencerChannel = mutations.mutate(
  MUTATION_EXPORT_INFLUENCER_CHANNEL
);
export const uploadCategories = mutations.mutate(MUTATION_UPLOAD_CATEGORIES);
export const uploadInfluencerChannel = mutations.mutate(
  MUTATION_UPLOAD_INFLUENCER_CHANNEL
);
